exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "area-planner .main-header-row th,\narea-planner .main-header-row td {\n  background: #eee;\n  font-size: 14px;\n  border: 1px solid #ccc !important;\n  text-align: center;\n}\narea-planner .spacer-row td {\n  background: #fff;\n  border: none !important;\n  height: 50px;\n}\narea-planner .spacer-row td:hover {\n  background: #fff !important;\n}\narea-planner .spacer-row.spacer-row-small td {\n  height: 10px;\n}\narea-planner .summary-row {\n  background: #eee;\n}\narea-planner .no-border {\n  border: none !important;\n}\narea-planner th {\n  white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/lib/loader.js!./TypeScript/shared/area-planner/area-planner.styles.less
// module id = 377
// module chunks = 10